"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("composer-lib/lib/constants");

var _comments = require("composer-lib/redux/actions/comments");

var _conversations = require("composer-lib/redux/actions/conversations");

var _actions = require("composer-lib/redux/actions");

var _composer = require("composer-lib/redux/actions/composer");

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _reactRedux = require("react-redux");

var _uiSettings = require("composer-lib/redux/actions/uiSettings");

var _googleDocs = require("composer-lib/redux/actions/googleDocs");

var _presenceToastHelpers = require("composer-lib/lib/helpers/presenceToastHelpers");

var _GoogleAccountSwitcher = _interopRequireDefault(require("composer-lib/components/modals/google/GoogleAccountSwitcher"));

var _GoogleAuthModal = _interopRequireDefault(require("composer-lib/components/modals/google/GoogleAuthModal"));

var _GoogleDocs = _interopRequireDefault(require("composer-lib/data/model/GoogleDocs"));

var _GoogleDocsPicker = _interopRequireDefault(require("composer-lib/components/modals/google/GoogleDocsPicker"));

var _GoogleErrorAlert = _interopRequireDefault(require("composer-lib/components/alerts/GoogleErrorAlert"));

var _lock = require("composer-lib/redux/actions/lock");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _LockedModal = _interopRequireDefault(require("composer-lib/components/modals/LockedModal"));

var _Presence = _interopRequireDefault(require("composer-lib/data/model/Presence"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _RevisionsContainer = _interopRequireDefault(require("composer-lib/containers/modals/RevisionsContainer"));

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _immutable = require("immutable");

var _ShareModal = _interopRequireDefault(require("composer-lib/components/modals/share/ShareModal"));

var _ToastContainer = _interopRequireDefault(require("composer-lib/containers/alerts/ToastContainer"));

var _UISettings = _interopRequireDefault(require("composer-lib/data/model/UISettings"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    composerSettings: state.composerSettings,
    composition: state.composition,
    googleDocs: state.googleDocs,
    lock: state.lock,
    pages: state.pages,
    presence: state.presence,
    saveState: state.save,
    toastData: state.toasts,
    uiSettings: state.uiSettings,
    users: state.users
  };
};

var mapDispatchToProps = {
  addToast: _actions.addToast,
  createBlogPost: _composer.createBlogPost,
  deleteCommentFromUpdate: _comments.deleteCommentFromUpdate,
  deleteConversationFromUpdate: _conversations.deleteConversationFromUpdate,
  dismissGoogleAuthError: _uiSettings.dismissGoogleAuthError,
  dismissGoogleAuthModal: _uiSettings.dismissGoogleAuthModal,
  dismissGoogleDocImportError: _uiSettings.dismissGoogleDocImportError,
  dismissGoogleDocImportImageUploadError: _uiSettings.dismissGoogleDocImportImageUploadError,
  dismissShareModal: _uiSettings.dismissShareModal,
  fetchGoogleAccessToken: _googleDocs.fetchGoogleAccessToken,
  fetchGoogleAccounts: _googleDocs.fetchGoogleAccounts,
  hideAccessPassedToast: _composer.hideAccessPassedToast,
  hideCompositionLockToast: _lock.hideCompositionLockToast,
  hideCompositionSaveFailedModal: _composer.hideCompositionSaveFailedModal,
  hideGoogleAccountSwitcher: _uiSettings.hideGoogleAccountSwitcher,
  hideGoogleDocsPicker: _uiSettings.hideGoogleDocsPicker,
  hideLockedModal: _lock.hideLockedModal,
  importGoogleDoc: _googleDocs.importGoogleDoc,
  removeToast: _actions.removeToast,
  removeUserFromComposition: _actions.removeUserFromComposition,
  showGoogleAuthError: _uiSettings.showGoogleAuthError,
  showGoogleAuthModal: _uiSettings.showGoogleAuthModal,
  showGoogleAccountSwitcher: _uiSettings.showGoogleAccountSwitcher,
  showGoogleDocsPicker: _uiSettings.showGoogleDocsPicker,
  updateCompositionFromUpdate: _composer.updateCompositionFromUpdate,
  updateGoogleAccount: _googleDocs.updateGoogleAccount,
  updateNewGoogleAccount: _googleDocs.updateNewGoogleAccount
}; // Container for Composer modal components

var ComposerModalsContainer = (0, _createReactClass.default)({
  displayName: "ComposerModalsContainer",
  propTypes: {
    auth: _propTypes.default.object,
    addToast: _propTypes.default.func,
    composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default).isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    dismissGoogleAuthError: _propTypes.default.func.isRequired,
    dismissGoogleAuthModal: _propTypes.default.func.isRequired,
    dismissGoogleDocImportError: _propTypes.default.func.isRequired,
    dismissGoogleDocImportImageUploadError: _propTypes.default.func.isRequired,
    dismissShareModal: _propTypes.default.func.isRequired,
    fetchGoogleAccessToken: _propTypes.default.func.isRequired,
    fetchGoogleAccounts: _propTypes.default.func.isRequired,
    googleDocs: _propTypes.default.instanceOf(_GoogleDocs.default).isRequired,
    hideCompositionLockToast: _propTypes.default.func,
    hideCompositionSaveFailedModal: _propTypes.default.func,
    hideGoogleAccountSwitcher: _propTypes.default.func.isRequired,
    hideGoogleDocsPicker: _propTypes.default.func.isRequired,
    hideLockedModal: _propTypes.default.func,
    importGoogleDoc: _propTypes.default.func.isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    presence: _propTypes.default.instanceOf(_Presence.default).isRequired,
    removeToast: _propTypes.default.func,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    uiSettings: _propTypes.default.instanceOf(_UISettings.default).isRequired,
    updateGoogleAccount: _propTypes.default.func.isRequired,
    updateNewGoogleAccount: _propTypes.default.func.isRequired,
    showGoogleAccountSwitcher: _propTypes.default.func.isRequired,
    showGoogleAuthError: _propTypes.default.func.isRequired,
    users: _propTypes.default.instanceOf(_Users.default).isRequired
  },
  childContextTypes: {
    gates: _propTypes.default.instanceOf(_immutable.Set)
  },
  getChildContext: function getChildContext() {
    return {
      gates: this.props.auth.gates
    };
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _this$props = this.props,
        lock = _this$props.lock,
        presence = _this$props.presence,
        users = _this$props.users;

    if ((lock.status === _constants.RequestStatus.FAILED || lock.status === _constants.RequestStatus.SUCCEEDED) && (users.status === _constants.RequestStatus.FAILED || users.status === _constants.RequestStatus.SUCCEEDED)) {
      this.showToast((0, _presenceToastHelpers.getCompositionLockedByAnotherUserToast)(this.props));

      if (prevProps.lock.lockedBy !== lock.lockedBy) {
        this.removeLockToast();
      }

      if (prevProps.presence.locker && presence.locker && prevProps.presence.locker !== presence.locker) {
        this.showToast((0, _presenceToastHelpers.getAccessPassedToast)(this.props));
        this.showToast((0, _presenceToastHelpers.getAccessGrantedToast)(this.props));
      }

      if (prevProps.presence.requestedAccess !== presence.requestedAccess) {
        this.showToast((0, _presenceToastHelpers.getAccessRequestedToast)(this.props));
      }

      if (prevProps.presence.requestRejected !== presence.requestRejected) {
        this.showToast((0, _presenceToastHelpers.getAccessRejectedToast)(this.props));
      }
    }
  },
  clearLockModal: function clearLockModal() {
    this.props.hideLockedModal();
  },
  reloadIgnoreChanges: function reloadIgnoreChanges() {
    // Don't show the unsaved changes alert warning before reloading
    window.onbeforeunload = null;
    window.location.reload();
  },
  removeLockToast: function removeLockToast() {
    var _this$props2 = this.props,
        auth = _this$props2.auth,
        lock = _this$props2.lock;
    var lockedByAnother = (0, _lockHelpers.compositionLockedByAnotherUser)(lock, auth);

    if (!lockedByAnother) {
      this.props.removeToast(_constants.LOCK_TOAST_ID);
    }
  },
  showToast: function showToast(toast) {
    if (toast) {
      this.props.addToast(toast);
    }
  },
  renderCompositionSaveFailedModal: function renderCompositionSaveFailedModal() {
    var _this$props3 = this.props,
        composition = _this$props3.composition,
        saveState = _this$props3.saveState;
    var requiredScope = saveState.requiredScope,
        saveFailed = saveState.saveFailed,
        saveFailedModal = saveState.saveFailedModal;

    if (!(saveFailed && saveFailedModal) || requiredScope && composition.get('type') === _constants.CompositionTypes.KNOWLEDGE_ARTICLE) {
      return null;
    }

    var langKey = requiredScope ? 'saveFailedCompositionScope' : 'saveFailedComposition';
    return _react.default.createElement(_LockedModal.default, {
      iconName: "warning",
      langKey: langKey,
      onPrimaryAction: this.props.hideCompositionSaveFailedModal,
      subHeadingOptions: {
        requiredScope: requiredScope
      }
    });
  },
  renderCompositionSelflockedModal: function renderCompositionSelflockedModal() {
    var _this$props4 = this.props,
        auth = _this$props4.auth,
        composition = _this$props4.composition,
        lock = _this$props4.lock;
    var toastDismissed = lock.toastDismissed;
    var lockedInAnotherSession = (0, _lockHelpers.compositionLockedByUserInAnotherSession)(lock, auth);

    if (toastDismissed || !lockedInAnotherSession || composition.isReadOnly()) {
      return null;
    }

    var subHeadingOptions = {
      user: auth.user
    };
    return _react.default.createElement(_LockedModal.default, {
      iconName: "duplicate",
      langKey: "sameUserComposition",
      onPrimaryAction: this.props.hideCompositionLockToast,
      onSecondaryAction: this.reloadIgnoreChanges,
      subHeadingOptions: subHeadingOptions
    });
  },
  renderContentLockedModal: function renderContentLockedModal() {
    var _this$props5 = this.props,
        auth = _this$props5.auth,
        saveState = _this$props5.saveState;
    var locked = saveState.locked,
        lockedBy = saveState.lockedBy,
        lockVisible = saveState.lockVisible;

    if (!(locked && lockVisible)) {
      return null;
    }

    var user = auth.user;
    var lockedUser = user.get('email') === lockedBy ? null : lockedBy;
    var langKey = lockedUser ? 'otherUser' : 'sameUser';
    var iconName = lockedUser ? 'time' : 'duplicate';
    var subHeadingOptions = {
      user: lockedUser
    };
    return _react.default.createElement(_LockedModal.default, {
      iconName: iconName,
      langKey: langKey,
      onPrimaryAction: this.clearLockModal,
      onSecondaryAction: this.reloadIgnoreChanges,
      subHeadingOptions: subHeadingOptions
    });
  },
  renderGoogleModals: function renderGoogleModals() {
    var _this$props6 = this.props,
        auth = _this$props6.auth,
        composerSettings = _this$props6.composerSettings,
        composition = _this$props6.composition,
        googleDocs = _this$props6.googleDocs,
        uiSettings = _this$props6.uiSettings;

    if (!composerSettings.get('features')[_constants.ComposerFeatures.GOOGLE_DOCS]) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "modals-container"
    }, _react.default.createElement(_GoogleErrorAlert.default, {
      dismissGoogleAuthError: this.props.dismissGoogleAuthError,
      dismissGoogleDocImportError: this.props.dismissGoogleDocImportError,
      dismissGoogleDocImportImageUploadError: this.props.dismissGoogleDocImportImageUploadError,
      uiSettings: uiSettings
    }), _react.default.createElement(_GoogleAuthModal.default, {
      dismissGoogleAuthModal: this.props.dismissGoogleAuthModal,
      showGoogleAuthError: this.props.showGoogleAuthError,
      uiSettings: uiSettings,
      updateNewGoogleAccount: this.props.updateNewGoogleAccount
    }), _react.default.createElement(_GoogleDocsPicker.default, {
      addToast: this.props.addToast,
      auth: auth,
      composerSettings: composerSettings,
      composition: composition,
      fetchGoogleAccessToken: this.props.fetchGoogleAccessToken,
      googleDocs: googleDocs,
      hideGoogleDocsPicker: this.props.hideGoogleDocsPicker,
      importGoogleDoc: this.props.importGoogleDoc,
      showGoogleAccountSwitcher: this.props.showGoogleAccountSwitcher,
      uiSettings: uiSettings
    }), _react.default.createElement(_GoogleAccountSwitcher.default, {
      fetchGoogleAccounts: this.props.fetchGoogleAccounts,
      googleDocs: googleDocs,
      hideGoogleAccountSwitcher: this.props.hideGoogleAccountSwitcher,
      hideGoogleDocsPicker: this.props.hideGoogleDocsPicker,
      showGoogleAuthError: this.props.showGoogleAuthError,
      uiSettings: uiSettings,
      updateGoogleAccount: this.props.updateGoogleAccount,
      updateNewGoogleAccount: this.props.updateNewGoogleAccount
    }));
  },
  renderRevisionsModal: function renderRevisionsModal() {
    var composerSettings = this.props.composerSettings;

    if (!composerSettings.get('features')[_constants.ComposerFeatures.REVISIONS]) {
      return null;
    }

    return _react.default.createElement(_RevisionsContainer.default, null);
  },
  render: function render() {
    var _this$props7 = this.props,
        composerSettings = _this$props7.composerSettings,
        uiSettings = _this$props7.uiSettings,
        users = _this$props7.users;
    return _react.default.createElement("div", null, _react.default.createElement(_ShareModal.default, {
      compositionId: composerSettings.compositionId,
      dismissShareModal: this.props.dismissShareModal,
      uiSettings: uiSettings,
      users: users
    }), this.renderGoogleModals(), this.renderCompositionSelflockedModal(), this.renderContentLockedModal(), this.renderCompositionSaveFailedModal(), _react.default.createElement(_ToastContainer.default, null), this.renderRevisionsModal());
  }
});
var reduxConnect = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ComposerModalsContainer);
var _default = reduxConnect;
exports.default = _default;
module.exports = exports.default;